function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("path", {
  d: "M178.5 382.5h102v-51h-102v51zM0 76.5v51h459v-51H0zM76.5 255h306v-51h-306v51z"
});

function SvgFilterResultsButton(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 459 459"
  }, props), _ref);
}

export default "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHZpZXdCb3g9IjAgMCA0NTkgNDU5Ij48cGF0aCBkPSJNMTc4LjUgMzgyLjVoMTAydi01MWgtMTAydjUxek0wIDc2LjV2NTFoNDU5di01MUgwek03Ni41IDI1NWgzMDZ2LTUxaC0zMDZ2NTF6Ii8+PC9zdmc+";
export { SvgFilterResultsButton as ReactComponent };